import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// Import translation files
import enTranslations from '../locales/en.json';
import msTranslations from '../locales/ms.json';
import jaTranslations from '../locales/ja.json';

const isDevelopment = import.meta.env.DEV;

const logMissingKey = (language, namespace, key) => {
  if (!isDevelopment) return;

  console.warn(
    `%c[i18n MISSING KEY] %c${language}/${namespace}: "${key}"`,
    'background: #ff6b6b; color: white; padding: 2px 6px; border-radius: 3px;',
    'color: #ff6b6b; font-weight: bold;'
  );

  const missingKeys = JSON.parse(localStorage.getItem('i18n_missing_keys') || '{}');
  if (!missingKeys[language]) missingKeys[language] = {};
  if (!missingKeys[language][namespace]) missingKeys[language][namespace] = [];

  if (!missingKeys[language][namespace].includes(key)) {
    missingKeys[language][namespace].push(key);
    localStorage.setItem('i18n_missing_keys', JSON.stringify(missingKeys));
  }
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources: {
      en: {
        translation: enTranslations,
      },
      ms: {
        translation: msTranslations,
      },
      ja: {
        translation: jaTranslations,
      },
    },
    fallbackLng: 'en',
    debug: isDevelopment,
    interpolation: {
      escapeValue: false, // React already escapes values
    },
    saveMissing: isDevelopment,
    saveMissingTo: 'all',
    missingKeyHandler: (lngs, namespace, key, fallbackValue) => {
      const languages = Array.isArray(lngs) ? lngs : [lngs];
      languages.forEach((language) => logMissingKey(language, namespace, key));

      if (isDevelopment) {
        console.warn(
          `%c[i18n MISSING] %c${key} %cin ${namespace}`,
          'background: #ffa500; color: white; padding: 2px 6px; border-radius: 3px;',
          'font-weight: bold;',
          'color: #666;'
        );
      }
    },
    detection: {
      order: ['localStorage', 'navigator'],
      caches: ['localStorage'],
    },
    ns: ['translation'],
    defaultNS: 'translation',
  });

export default i18n;
